import { useCallback } from 'react';
import { useQuery, useMutation } from '@ts-core/lib/apollo';

import { useMutationCompletionHandler, getErrorMessage } from '@ts-core/lib/apollo';

import { getLessonQuery, getLessonsQuery } from '../graphql/queries';
import { updateLessonMutation, createLessonMutation } from '../graphql/mutations';

export default function useLesson({ courseId, groupId, lessonId, onLessonCreated, onLessonUpdated }) {
  const { onError, addItemToCache } = useMutationCompletionHandler();

  /**
   * Get lesson
   */
  const { loading, data, error } = useQuery(getLessonQuery, {
    variables: { courseId, groupId, lessonId },
    skip: !courseId || !groupId || !lessonId,
  });
  const lesson = data?.lesson;

  /**
   * Create lesson
   */
  const [createLesson, { loading: creatingLesson }] = useMutation(createLessonMutation, {
    onError,
    onCompleted: onLessonCreated,
    update: addItemToCache({
      query: getLessonsQuery,
      variables: { courseId, groupId },
      queryField: 'lessons',
      mutationField: 'lesson',
    }),
  });
  const onCreateLesson = useCallback(
    (input) => {
      createLesson({ variables: { courseId, groupId, input } });
    },
    [createLesson, courseId, groupId]
  );

  /**
   * Update Lesson
   */
  const [updateLesson, { loading: updatingLesson }] = useMutation(updateLessonMutation, {
    onError,
    onCompleted: onLessonUpdated,
  });
  const onUpdateLesson = useCallback(
    (input) => {
      updateLesson({ variables: { courseId, groupId, lessonId, input } });
    },
    [updateLesson, courseId, groupId, lessonId]
  );

  return {
    lesson,
    loading,
    error: getErrorMessage({ error }),

    onCreateLesson,
    creatingLesson,

    onUpdateLesson,
    updatingLesson,
  };
}
